import CheckInFeedback from './CheckInFeedback';

export default CheckInFeedback;
